import { AbstractParseTreeVisitor } from 'antlr4ts/tree/AbstractParseTreeVisitor';
export class KojiAstBuilder extends AbstractParseTreeVisitor {
    constructor() {
        super(...arguments);
        this.inlines = [];
        this.blocks = [];
        this.parens = [];
    }
    defaultResult() { }
    visit(ctx) {
        return {
            type: 'document',
            name: 'document',
            body: ctx.list().map((l) => this.visitList(l)),
            inlines: this.inlines,
            blocks: this.blocks,
            parens: this.parens
        };
    }
    visitList(ctx) {
        const block = ctx.block();
        const inline = ctx.inline();
        const syntaxSugar = ctx.syntaxSugar();
        const textSegment = ctx.textSegment();
        const lb = ctx.Lb();
        if (block) {
            const blockNode = this.visitBlock(block);
            return blockNode;
        }
        else if (inline) {
            const inlineNode = this.visitInline(inline);
            return inlineNode;
        }
        else if (syntaxSugar) {
            const inlineNode = this.visitSyntaxSugar(syntaxSugar);
            return inlineNode;
        }
        else if (textSegment) {
            return textSegment.text;
        }
        else if (lb) {
            return '\n';
        }
    }
    visitBlock(ctx) {
        const block1 = ctx.block1();
        const block2 = ctx.block2();
        const block3 = ctx.block3();
        const block4 = ctx.block4();
        const block5 = ctx.block5();
        let node;
        if (block1)
            node = this.visitBlock1(block1);
        if (block2)
            node = this.visitBlock2(block2);
        if (block3)
            node = this.visitBlock3(block3);
        if (block4)
            node = this.visitBlock4(block4);
        if (block5)
            node = this.visitBlock5(block5);
        return node;
    }
    locationOfBlockContent(ctx) {
        const text = ctx.text;
        const loc = this.loc(ctx);
        return { start: loc.start + text.indexOf('\n'), stop: loc.stop };
    }
    visitBlock1(ctx) {
        const content = ctx.blockContent1();
        const name = ctx.ElemName().text;
        const attrs = this.processAttrs(ctx);
        const node = {
            type: 'block',
            name: name,
            children: [content.map((c) => this.visitBlockContent1(c))],
            ...attrs,
            location: this.loc(ctx),
            level: 1,
            content: this.locationOfBlockContent(ctx)
        };
        this.blocks.push(node);
        return node;
    }
    visitBlockContent1(ctx) {
        const lb = ctx.Lb();
        const inline = ctx.inline();
        const textSegment = ctx.textSegment();
        const syntaxSugar = ctx.syntaxSugar();
        const block2 = ctx.block2();
        const block3 = ctx.block3();
        const block4 = ctx.block4();
        const block5 = ctx.block5();
        if (lb)
            return '\n';
        if (inline)
            return this.visitInline(inline);
        if (textSegment)
            return textSegment.text;
        if (syntaxSugar)
            return this.visitSyntaxSugar(syntaxSugar);
        if (block2)
            return this.visitBlock2(block2);
        if (block3)
            return this.visitBlock3(block3);
        if (block4)
            return this.visitBlock4(block4);
        if (block5)
            return this.visitBlock5(block5);
    }
    visitBlock2(ctx) {
        const content = ctx.blockContent2();
        const name = ctx.ElemName().text;
        const attrs = this.processAttrs(ctx);
        const node = {
            type: 'block',
            name: name,
            children: [content.map((c) => this.visitBlockContent2(c))],
            ...attrs,
            location: this.loc(ctx),
            level: 2,
            content: this.locationOfBlockContent(ctx)
        };
        this.blocks.push(node);
        return node;
    }
    visitBlockContent2(ctx) {
        const lb = ctx.Lb();
        const inline = ctx.inline();
        const textSegment = ctx.textSegment();
        const syntaxSugar = ctx.syntaxSugar();
        const block3 = ctx.block3();
        const block4 = ctx.block4();
        const block5 = ctx.block5();
        if (lb)
            return '\n';
        if (inline)
            return this.visitInline(inline);
        if (textSegment)
            return textSegment.text;
        if (syntaxSugar)
            return this.visitSyntaxSugar(syntaxSugar);
        if (block3)
            return this.visitBlock3(block3);
        if (block4)
            return this.visitBlock4(block4);
        if (block5)
            return this.visitBlock5(block5);
    }
    visitBlock3(ctx) {
        const content = ctx.blockContent3();
        const name = ctx.ElemName().text;
        const attrs = this.processAttrs(ctx);
        const node = {
            type: 'block',
            name: name,
            children: [content.map((c) => this.visitBlockContent3(c))],
            ...attrs,
            location: this.loc(ctx),
            level: 3,
            content: this.locationOfBlockContent(ctx)
        };
        this.blocks.push(node);
        return node;
    }
    visitBlockContent3(ctx) {
        const lb = ctx.Lb();
        const inline = ctx.inline();
        const textSegment = ctx.textSegment();
        const syntaxSugar = ctx.syntaxSugar();
        const block4 = ctx.block4();
        const block5 = ctx.block5();
        if (lb)
            return '\n';
        if (inline)
            return this.visitInline(inline);
        if (textSegment)
            return textSegment.text;
        if (syntaxSugar)
            return this.visitSyntaxSugar(syntaxSugar);
        if (block4)
            return this.visitBlock4(block4);
        if (block5)
            return this.visitBlock5(block5);
    }
    visitBlock4(ctx) {
        const content = ctx.blockContent4();
        const name = ctx.ElemName().text;
        const attrs = this.processAttrs(ctx);
        const node = {
            type: 'block',
            name: name,
            children: [content.map((c) => this.visitBlockContent4(c))],
            ...attrs,
            location: this.loc(ctx),
            level: 4,
            content: this.locationOfBlockContent(ctx)
        };
        this.blocks.push(node);
        return node;
    }
    visitBlockContent4(ctx) {
        const lb = ctx.Lb();
        const inline = ctx.inline();
        const textSegment = ctx.textSegment();
        const syntaxSugar = ctx.syntaxSugar();
        const block5 = ctx.block5();
        if (lb)
            return '\n';
        if (inline)
            return this.visitInline(inline);
        if (textSegment)
            return textSegment.text;
        if (syntaxSugar)
            return this.visitSyntaxSugar(syntaxSugar);
        if (block5)
            return this.visitBlock5(block5);
    }
    visitBlock5(ctx) {
        const content = ctx.blockContent5();
        const name = ctx.ElemName().text;
        const attrs = this.processAttrs(ctx);
        const node = {
            type: 'block',
            name: name,
            children: [content.map((c) => this.visitBlockContent5(c))],
            ...attrs,
            location: this.loc(ctx),
            level: 5,
            content: this.locationOfBlockContent(ctx)
        };
        this.blocks.push(node);
        return node;
    }
    visitBlockContent5(ctx) {
        const lb = ctx.Lb();
        const inline = ctx.inline();
        const textSegment = ctx.textSegment();
        const syntaxSugar = ctx.syntaxSugar();
        if (lb)
            return '\n';
        if (inline)
            return this.visitInline(inline);
        if (textSegment)
            return textSegment.text;
        if (syntaxSugar)
            return this.visitSyntaxSugar(syntaxSugar);
    }
    processAttrs(ctx) {
        const id = ctx.ID();
        const classes = ctx.Class();
        const attrs = {};
        if (id)
            attrs.id = id.text.slice(1);
        if (classes)
            attrs.classes = classes.map((c) => c.text.slice(1));
        return attrs;
    }
    processPostAttrs(ctx) {
        const attrs = {};
        const id = ctx.ID();
        const classes = ctx.Class();
        if (id)
            attrs.id = id.text.slice(1);
        if (classes)
            attrs.classes = classes.map((c) => c.text.slice(1));
        return attrs;
    }
    visitInline(ctx) {
        const name = ctx.ElemName().text;
        const content = ctx._content;
        const children = content.map((c) => this.visitInlineContentSeq(c));
        const attrs = this.processAttrs(ctx);
        const location = this.loc(ctx);
        this.parens.push(location);
        const node = {
            type: 'inline',
            name: name,
            children: children,
            ...attrs,
            location,
            paren: { start: location.start, stop: location.stop },
            isSyntaxSugar: false
        };
        this.inlines.push(node);
        return node;
    }
    visitInlineContentSeq(ctx) {
        return ctx.inlineContent().map((c) => this.visitInlineContent(c));
    }
    visitInlineContent(ctx) {
        const lb = ctx.Lb();
        const inline = ctx.inline();
        const textSegment = ctx.textSegment();
        const syntaxSugar = ctx.syntaxSugar();
        if (lb) {
            return '\n';
        }
        else if (inline) {
            return this.visitInline(inline);
        }
        else if (textSegment) {
            return textSegment.text;
        }
        else if (syntaxSugar) {
            return this.visitSyntaxSugar(syntaxSugar);
        }
    }
    visitSyntaxSugar(ctx) {
        const furigana = ctx.furigana();
        const annotation = ctx.annotation();
        const okurigana = ctx.okurigana();
        const kaeriten = ctx.kaeriten();
        const tateten = ctx.tateten();
        const illegible = ctx.illegible();
        const bugHole = ctx.bugHole();
        const person = ctx.person();
        const place = ctx.place();
        const date = ctx.date();
        const location = this.loc(ctx);
        let node;
        if (furigana) {
            const parenStart = location.start + ctx.text.indexOf('（');
            this.parens.push({ start: parenStart, stop: location.stop });
            node = {
                name: '振り仮名',
                type: 'inline',
                children: [[furigana._target.text], [furigana._right.text]],
                location,
                isSyntaxSugar: true
            };
            if (furigana._left)
                node.children.push([furigana._left.text]);
        }
        else if (annotation) {
            this.parens.push(location);
            node = {
                type: 'inline',
                name: '注釈',
                children: [[annotation._content.text]],
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (okurigana) {
            node = {
                type: 'inline',
                name: '送り仮名',
                children: [[okurigana._content.text]],
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (kaeriten) {
            node = {
                type: 'inline',
                name: '返り点',
                children: [[kaeriten._content.text]],
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (tateten) {
            node = {
                type: 'inline',
                name: '竪点',
                children: [[tateten.text]],
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (illegible) {
            node = {
                type: 'inline',
                name: '難読',
                children: [[illegible.text]],
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (bugHole) {
            node = {
                type: 'inline',
                name: '虫損',
                children: [[bugHole.text]],
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (person) {
            this.parens.push(location);
            const content = person._content;
            const children = [content.map((c) => this.visitInlineContent(c))];
            const attrsCtx = person.postPositionedAttrs();
            const attrs = attrsCtx ? this.processAttrs(person.postPositionedAttrs()) : {};
            node = {
                type: 'inline',
                name: '人物',
                ...attrs,
                children,
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (place) {
            this.parens.push(location);
            const content = place._content;
            const children = [content.map((c) => this.visitInlineContent(c))];
            const attrsCtx = place.postPositionedAttrs();
            const attrs = attrsCtx ? this.processAttrs(place.postPositionedAttrs()) : {};
            node = {
                type: 'inline',
                name: '場所',
                ...attrs,
                children,
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else if (date) {
            this.parens.push(location);
            const content = date._content;
            const children = [content.map((c) => this.visitInlineContent(c))];
            const attrsCtx = date.postPositionedAttrs();
            const attrs = attrsCtx ? this.processAttrs(date.postPositionedAttrs()) : {};
            node = {
                type: 'inline',
                name: '日時',
                ...attrs,
                children,
                location: this.loc(ctx),
                isSyntaxSugar: true
            };
        }
        else {
            throw new Error('parsing error');
        }
        this.inlines.push(node);
        return node;
    }
    loc(ctx) {
        return { start: ctx.start.startIndex, stop: ctx.stop.stopIndex };
    }
    visitChildren() { }
    visitErrorNode() { }
    visitTerminal() { }
    visitKoji(ctx) { }
}
//# sourceMappingURL=data:application/json;base64,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